export const handleObjectMessages = (data: any) => {
  const messagesFormatted =
    data.messages.length > 0
      ? data.messages.map((mes: any) => {
          return {
            ...mes,
            flaggedMessages:
              data?.flaggedMessages?.flags?.filter(
                (flaggedMessage: any) => flaggedMessage.message.id === mes.id
              )[0] || null,
          };
        })
      : [];
  return messagesFormatted;
};
